import React from 'react'
// import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'

const ChatList = ({ data }) => {
  // console.log('data: ', data)
  const _renderChatCard = (val) => {
    const { key, roomNumber, userName, propertyName, created, last_message, support_completed, waiting_support } = val
    const setClass = () => {
      if (support_completed) {
        return 'card_flag done'
      } else {
        if (waiting_support) {
          return 'card_flag waiting_support'
        } else {
          return 'card_flag waiting_reply'
        }
      }
    }
    const status = () => {
      if (support_completed) {
        return '対応済'
      } else {
        if (waiting_support) {
          return '対応待ち'
        } else {
          return '返事待ち'
        }
      }
    }
    return (
      <Link to={`/chat/room/${key}`} className={`${support_completed ? 'done ' : ''}chat_card`} key={key}>
        <div className="card_header flex justify-between align-center">
          <h4>{ userName }</h4>
          <div className={setClass()}>{status()}</div>
        </div>
        <div className="card_subheader">
          <h5>{propertyName} - {roomNumber}</h5>
        </div>
        <div className="card_content">
          <div className="created">{moment(last_message).format('YYYY/MM/DD　HH:mm')}更新</div>
          <div className="created">{moment(created).format('YYYY/MM/DD　HH:mm')}作成</div>
        </div>
      </Link>
    )
  }

  const _renderChatList = () => {
    const sortedData = _(data)
      .map((val, key) => {
        return val
      })
      .sortBy((item) => {
        return !item.waiting_support
      })
      .value()

    return sortedData.map((item) => {
      return _renderChatCard(item)
    })
  }

  return (
    <div className="list_container flex">
      {
        _renderChatList()
      }
    </div>
  )
}
export default ChatList



// WEBPACK FOOTER //
// ./src/components/Chat/ChatList.js